var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg45Covered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84635",
    "data-name": "Group 84635",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.671,
    height: 126.99,
    viewBox: "0 0 112.671 126.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24666",
    "data-name": "Rectangle 24666",
    width: 112.671,
    height: 126.99,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84634",
    "data-name": "Group 84634",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240113",
    "data-name": "Path 240113",
    d: "M49.1,126.99a.659.659,0,0,1-.621-.438c-2.571-7.186-5.232-9.052-10.534-12.769-1.625-1.139-3.466-2.429-5.63-4.092-.637-.489-1.319-.989-2.038-1.517-5.172-3.793-12.256-8.989-18.3-21.407C4.8,72.015.884,51,0,22.523a.659.659,0,0,1,.5-.66C14.41,18.306,33.986,11.65,48.232.146a.66.66,0,0,1,.809-.015C64.635,11.739,87.717,18.954,96.918,21.517a.66.66,0,0,1,.481.686c-.056.726-.129,1.861-.213,3.158-.23,3.558-.517,7.985-.762,9.21a.66.66,0,1,1-1.294-.259c.227-1.139.523-5.7.738-9.036.066-1.016.126-1.933.175-2.633-9.512-2.68-31.908-9.8-47.38-21.15C34.445,12.81,15.213,19.422,1.336,23.01c2.072,63.817,19.374,76.508,29.723,84.1.728.534,1.418,1.04,2.062,1.535,2.141,1.645,3.97,2.927,5.584,4.058,5.083,3.563,7.839,5.495,10.357,11.669,1.8-4.181,6.678-9.447,14.539-15.689,3.834-3.045,7.937-5.939,11.557-8.493,1.894-1.337,3.684-2.6,5.163-3.694a.66.66,0,1,1,.785,1.06c-1.49,1.1-3.286,2.372-5.187,3.713-3.606,2.544-7.692,5.427-11.5,8.448-8.8,6.988-13.739,12.627-14.676,16.76a.661.661,0,0,1-.6.513H49.1",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240114",
    "data-name": "Path 240114",
    d: "M48.888,112.512a.222.222,0,0,1-.181-.094c-1.321-1.9-5.641-5.659-12.84-11.184C26.28,93.878,19.881,84.762,15.73,72.546c-3.665-10.785-5.72-24.033-6.871-44.3a.219.219,0,0,1,.165-.225c17.472-4.477,30.33-10.23,39.308-17.589a.222.222,0,0,1,.275,0c9.071,7.043,25.1,11.88,34.685,14.77,2.114.638,3.939,1.189,5.256,1.635a.219.219,0,0,1,.148.233l-.055.485c-.125,1.1-.315,2.772-.315,3.2a.22.22,0,1,1-.44,0c0-.449.191-2.131.318-3.245l.035-.309c-1.3-.434-3.053-.964-5.074-1.573-9.561-2.885-25.53-7.7-34.689-14.737C39.484,18.206,26.667,23.938,9.308,28.4c2.013,35.2,6.9,57.194,26.827,72.484,6.921,5.311,11.2,9.014,12.741,11.018,1.812-2.613,10.175-10.353,16.525-14.519a.22.22,0,0,1,.241.368c-6.548,4.3-15.235,12.389-16.565,14.65a.218.218,0,0,1-.181.109Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240115",
    "data-name": "Path 240115",
    d: "M97.469,44.614a8.457,8.457,0,1,1,0,11.96,8.456,8.456,0,0,1,0-11.96",
    transform: "translate(0 0)",
    fill: "#fefbf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240116",
    "data-name": "Path 240116",
    d: "M98.381,47.432a5.984,5.984,0,1,1,1.944,8.236,5.984,5.984,0,0,1-1.944-8.236",
    transform: "translate(0 0)",
    fill: "#fefaf6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240117",
    "data-name": "Path 240117",
    d: "M71.316,69.362a1.648,1.648,0,1,1-1.477,1.8,1.648,1.648,0,0,1,1.477-1.8",
    transform: "translate(0 0)",
    fill: "#fdf7f0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240118",
    "data-name": "Path 240118",
    d: "M89.882,67.291a1.648,1.648,0,1,1-1.224,1.983,1.649,1.649,0,0,1,1.224-1.983",
    transform: "translate(0 0)",
    fill: "#fefcf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240119",
    "data-name": "Path 240119",
    d: "M80.864,66.267a1.648,1.648,0,1,0-1.648-1.648,1.651,1.651,0,0,0,1.648,1.648",
    transform: "translate(0 0)",
    fill: "#fefbf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240120",
    "data-name": "Path 240120",
    d: "M98.154,62.047a1.649,1.649,0,1,1,.892,2.154,1.649,1.649,0,0,1-.892-2.154",
    transform: "translate(0 0)",
    fill: "#fd930d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240121",
    "data-name": "Path 240121",
    d: "M69.349,76.953v7.6a22.7,22.7,0,0,0,4.233,3.526V76.953A1.082,1.082,0,0,0,72.5,75.872H70.43a1.083,1.083,0,0,0-1.081,1.081",
    transform: "translate(0 0)",
    fill: "#fdf7f0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240122",
    "data-name": "Path 240122",
    d: "M78.747,70.974V90.54a22.434,22.434,0,0,0,4.233.948V70.974A1.082,1.082,0,0,0,81.9,69.893H79.828A1.083,1.083,0,0,0,78.747,70.974Z",
    transform: "translate(0 0)",
    fill: "#fefbf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240123",
    "data-name": "Path 240123",
    d: "M88.146,74.815V91.541a22.436,22.436,0,0,0,4.232-.855V74.815A1.082,1.082,0,0,0,91.3,73.734H89.226a1.082,1.082,0,0,0-1.08,1.081",
    transform: "translate(0 0)",
    fill: "#fefcf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240124",
    "data-name": "Path 240124",
    d: "M97.544,68.865v19.5a22.635,22.635,0,0,0,4.233-3.339V68.865a1.082,1.082,0,0,0-1.081-1.081H98.625a1.083,1.083,0,0,0-1.081,1.081",
    transform: "translate(0 0)",
    fill: "#fd930d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240125",
    "data-name": "Path 240125",
    d: "M92.053,68.618l-.843-1.257,6.628-4.447.844,1.256Zm-3.6.294-6.4-2.922.628-1.377,6.4,2.922Zm-15.195,1.8L72.4,69.458l6.673-4.54.851,1.252Z",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240126",
    "data-name": "Path 240126",
    d: "M63.277,71.442a.76.76,0,0,1-.531-.216l-3.258-3.2a.756.756,0,1,1,1.059-1.08l1.923,1.888A23.341,23.341,0,0,1,92.611,46.777a.757.757,0,1,1-.441,1.448A21.828,21.828,0,0,0,63.983,68.886l1.955-1.99a.757.757,0,1,1,1.08,1.06l-3.2,3.26a.753.753,0,0,1-.54.226M85.795,92.416a23.342,23.342,0,0,0,22.6-29.111l2.339,1.323a.757.757,0,0,0,.746-1.318L107.5,61.062a.756.756,0,0,0-1.031.286l-2.248,3.977a.757.757,0,0,0,1.318.745l1.375-2.434a21.817,21.817,0,1,1-42.326,10.6.757.757,0,1,0-1.471.356,23.432,23.432,0,0,0,8.144,12.746A23.078,23.078,0,0,0,85.795,92.416Z",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240127",
    "data-name": "Path 240127",
    d: "M103.456,42.887a7.7,7.7,0,1,0,7.7,7.7,7.71,7.71,0,0,0-7.7-7.7m0,16.917a9.215,9.215,0,1,1,9.215-9.216,9.226,9.226,0,0,1-9.215,9.216",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240128",
    "data-name": "Path 240128",
    d: "M103.456,45.364a5.224,5.224,0,1,0,5.224,5.224,5.23,5.23,0,0,0-5.224-5.224m0,11.962a6.738,6.738,0,1,1,6.737-6.738,6.745,6.745,0,0,1-6.737,6.738",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240129",
    "data-name": "Path 240129",
    d: "M103.476,55.322a.756.756,0,0,1-.756-.739l-.006-.248a2.925,2.925,0,0,1-1.211-.764.756.756,0,1,1,1.037-1.1c.39.367.561.451.917.451a.791.791,0,1,0,0-1.547,2.388,2.388,0,0,1-2.472-2.288,2.317,2.317,0,0,1,1.7-2.174l-.006-.282a.757.757,0,1,1,1.514-.036l.007.332a2.626,2.626,0,0,1,1.409.921.757.757,0,0,1-1.265.831,1.708,1.708,0,0,0-.888-.366.792.792,0,1,0,0,1.548,2.387,2.387,0,0,1,2.471,2.288,2.317,2.317,0,0,1-1.7,2.173l.005.227a.756.756,0,0,1-.738.774Z",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240130",
    "data-name": "Path 240130",
    d: "M74.341,88.074H72.827V76.627H70.106v7.921H68.593V75.87a.757.757,0,0,1,.757-.757h4.234a.758.758,0,0,1,.757.757Zm23.96.29H96.787V67.782a.757.757,0,0,1,.757-.757h4.234a.756.756,0,0,1,.756.757V85.026h-1.513V68.539H98.3ZM83.738,91.486H82.224V70.648H79.5v19.89H77.991V69.891a.757.757,0,0,1,.757-.757h4.233a.756.756,0,0,1,.757.757Zm5.165.053H87.389V73.732a.757.757,0,0,1,.757-.757H92.38a.757.757,0,0,1,.757.757V90.684H91.623V74.489H88.9Z",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240131",
    "data-name": "Path 240131",
    d: "M99.661,61.783a.891.891,0,1,0,.891.891.892.892,0,0,0-.891-.891m0,3.3a2.4,2.4,0,1,1,2.4-2.4,2.407,2.407,0,0,1-2.4,2.4m-18.8-1.352a.891.891,0,1,0,.891.891.893.893,0,0,0-.891-.891m0,3.3a2.405,2.405,0,1,1,2.4-2.405,2.408,2.408,0,0,1-2.4,2.405m9.4.995a.891.891,0,1,0,.891.891.892.892,0,0,0-.891-.891m0,3.3a2.405,2.405,0,1,1,2.4-2.405,2.408,2.408,0,0,1-2.4,2.405m-18.8-1.194a.891.891,0,1,0,.891.892.893.893,0,0,0-.891-.892m0,3.3a2.4,2.4,0,1,1,2.4-2.4,2.408,2.408,0,0,1-2.4,2.4",
    transform: "translate(0 0)",
    fill: "#515255",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45Covered);
export default __webpack_public_path__ + "static/media/4.5_Covered.a5ef0a57c05735b9c180ab9e2fe0df42.svg";
export { ForwardRef as ReactComponent };